import { motion } from 'framer-motion';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

const KeepSwipingButton = ({ handleClose }: { handleClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      whileTap={{ scale: 0.9 }}
      style={buttonStyle}
      onClick={handleClose}
    >
      <span style={{ fontSize: '17px' }}>
        {t('matched_popup.keep_swiping')}
      </span>
    </motion.div>
  );
};

const buttonStyle: CSSProperties = {
  width: 'calc(100% - 65px)',
  height: '50px',
  color: '#fff',
  border: 'none',
  borderRadius: '45px',
  background: '#343434',
  fontSize: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  appearance: 'none',
  fontWeight: 500,
  marginBottom: '10px'
};

export default KeepSwipingButton;
